import PropTypes from 'prop-types';

import AsyncTableComponent from '../Table/AsyncTableContainer';

import { formatDate } from '../../utils';
import { formatTextSelect } from '../Forms/utils';
import { getExportTitle } from '../ViewExport/utils';
import { humanizeDuration } from './utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';
import { CALL_CENTER_ACTION_OPTIONS } from './constants';

import {
  DATE_RANGES_TYPES,
  TABLE_DATA_TYPES,
  fullTimeDateFormat24,
} from '../../staticData';
import { ButtonLink } from '../Button';
import { actionFilter, agentFilter, limitFilter } from '../Table/filters';
import Tooltip from '../Tooltip';
import RemoteDoormanAgentsLogExport from './RemoteDoormanAgentsLogExport';

const RemoteDoormanAgentsLogComponent = (props) => {
  const {
    onLoad,
    items,
    getItems,
    listParams,
    listKey,
    onExport,
    agentOptions,
    onOpenCallDetailsModal,
  } = props;

  const columns = [
    {
      Header: 'Agent',
      id: 'cc_agent',
      headerClassName: 'sort',
      accessor: ({ callCenterAgent }) => callCenterAgent?.name || 'N/A',
    },
    {
      Header: 'Datetime',
      id: 'created_at',
      headerClassName: 'sort',
      defaultSortDesc: true,
      accessor: ({ timestamp }) =>
        formatDate(timestamp, true, fullTimeDateFormat24),
    },
    {
      Header: 'Call ID',
      id: 'call_id',
      sortable: false,
      accessor: ({ callSid }, isExport) => {
        if (!callSid) return 'N/A';
        if (isExport) return callSid;
        return (
          <ButtonLink onClick={() => onOpenCallDetailsModal(callSid)}>
            {callSid}
          </ButtonLink>
        );
      },
    },
    {
      Header: 'Action',
      id: 'action',
      sortable: false,
      accessor: ({ description }, isExport) => {
        if (!description) return 'N/A';
        if (isExport) return description;
        return <Tooltip tooltip={description}>{description}</Tooltip>;
      },
    },
    {
      Header: 'Time since previous action',
      id: 'time',
      sortable: false,
      accessor: ({ fromPreviousEvent }) =>
        humanizeDuration(fromPreviousEvent) || 'N/A',
    },
  ];

  const filters = [
    limitFilter(listParams),
    agentFilter(listParams, agentOptions),
    actionFilter(listParams, formatTextSelect(CALL_CENTER_ACTION_OPTIONS)),
  ];

  const defaultParams = {
    offset: '0',
    q: null,
    created_at_after: null,
    created_at_before: null,
  };

  const action = null;
  const fieldsForBackendSort = [TABLE_CONSTANTS.created_at];
  const tableDataType = TABLE_DATA_TYPES.items;

  const title = 'Remote Doorman Agents Log';
  const exportTitle = getExportTitle(title);
  const exportActions = (
    <RemoteDoormanAgentsLogExport
      title={exportTitle}
      getDataForExport={onExport}
      columns={columns}
    />
  );

  return (
    <AsyncTableComponent
      tableId={TABLE_ID.remoteDoormanAgentsLog}
      title={title}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.created_at}
      fieldsForBackendSort={fieldsForBackendSort}
      filters={filters}
      showFiltersAreApplied={false}
      onLoad={onLoad}
      items={items}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={action}
      dateRangeType={DATE_RANGES_TYPES.created_at}
      datePicker
      manual
      defaultSortDesc
      exportActions={exportActions}
      isHideSearch
    />
  );
};

RemoteDoormanAgentsLogComponent.propTypes = {
  onLoad: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  listKey: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
  onOpenCallDetailsModal: PropTypes.func.isRequired,
  agentOptions: PropTypes.instanceOf(Object).isRequired,
};

export default RemoteDoormanAgentsLogComponent;
